module.exports = __webpack_public_path__ + "static/media/arrow.bae18aa4.svg";